import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { language, toggleLanguage, t, isRTL } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // If we're already on the home page, just scroll
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      setIsMobileMenuOpen(false);
      return;
    }

    // Otherwise navigate to home and pass the target section in state
    navigate('/', { state: { scrollTo: sectionId } });
    setIsMobileMenuOpen(false);
  };

  return (
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">
          <div className="logo" onClick={() => scrollToSection('home')}>
            <span className="logo-text">{isRTL ? 'دكتور / أدهم الشرقاوي' : 'Dr / Adham Elsharkawy'}</span>
          </div>

          <div className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
            <a href="#header-wrapper" onClick={(e) => { e.preventDefault(); scrollToSection('header-wrapper'); }}>{t.nav.home}</a>
            <a href="#section-2" onClick={(e) => { e.preventDefault(); scrollToSection('section-2'); }}>{t.nav.services}</a>
            <a href="#section-3" onClick={(e) => { e.preventDefault(); scrollToSection('section-3'); }}>{t.nav.works}</a>
            <a href="#section-projects" onClick={(e) => { e.preventDefault(); scrollToSection('section-projects'); }}>{t.nav.projects}</a>
            <a href="#section-8" onClick={(e) => { e.preventDefault(); scrollToSection('section-8'); }}>{t.nav.experience}</a>
            <a href="#section-5" onClick={(e) => { e.preventDefault(); scrollToSection('section-5'); }}>{t.nav.quotes}</a>
            <a href="#section-6" onClick={(e) => { e.preventDefault(); scrollToSection('section-6'); }}>{t.nav.partners}</a>
            <a href="#section-9" onClick={(e) => { e.preventDefault(); scrollToSection('section-9'); }}>{t.nav.videos}</a>
            <a href="#section-7" onClick={(e) => { e.preventDefault(); scrollToSection('section-7'); }}>{t.nav.contact}</a>

            <button className="lang-toggle" onClick={toggleLanguage}>
              {language === 'en' ? 'العربية' : 'English'}
            </button>
          </div>

          <div className="mobile-controls">
            <button className="mobile-lang-toggle" onClick={toggleLanguage}>
              {language === 'en' ? 'العربية' : 'English'}
            </button>

            <div
                className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </nav>
  );
};

export default Navbar;
